import React, {Component, useEffect} from 'react'
import { withApollo } from 'react-apollo'
import PropTypes from 'prop-types'
import { Tabs, Typography, Spin, Row, Col, Input, message, Button, InputNumber, Radio, Form, Modal, Checkbox } from 'antd'
import moment from 'moment'
import { inputTax, formInputTaxDefult, checkTypeInputButtonNews } from '../../../utils/formInput'
import { changeFormatdate } from '../../../utils/formatdate'
import { convertToHTMl } from '../../../utils/markDown'
import { Queries, Mutations } from '../../../graphql'

const { Text, Title } = Typography
class FormInputTax extends React.PureComponent {
    state = {
        formTaxDraftState: [],
        templateForm: [],
        modalShow: false,
        valuesForm: [],
        description: null,
        showTempalteInput: null,
        dropdownListRelation:[],
        dropdownListTitleMale: [],
        dropdownListTitleFemale: [],
        modalGuideLineTax: false,
        checkBoxForm: true
    }

    onChangeConditions =  (valueInput, keysInput, keySession, name) =>{
        const { templateForm, formTaxDraftState, showTempalteInput } = this.state
        const { formTaxDraft } = this.props
        // console.log(valueInput)
        if(valueInput == 0){
            // console.log(keysInput)
            templateForm[keySession].input.map((value, keys) =>{
                const fname = value.name;
                if(name == 'isSponserDisabled'){
                    this.showTextInputSponser(0, false)
                }
                
                if(keys !== 0){
                    templateForm[keySession].input[keys].disable = true
                    if(checkTypeInputButtonNews(value.name)){
                        this.props.form.setFieldsValue({
                            [fname]: 0,
                        });
                    }
                }else{
                    formTaxDraftState[value.name] = valueInput
                }
            })
        }else if(valueInput == 1){
            templateForm[keySession].input.map((value, keys) =>{
                const fname = value.name;
                if(name == 'isSponserDisabled'){
                    this.showTextInputSponser(parseInt(showTempalteInput), true)
                }
                if(keys !== 0){
                    templateForm[keySession].input[keys].disable = false
                    if(formTaxDraftState[value.name]){
                        this.props.form.setFieldsValue({
                            [fname]: formTaxDraftState[value.name],
                        });
                    }else{
                        formTaxDraftState[value.name] = ''
                    }
                }else{
                    formTaxDraftState[value.name] = valueInput
                }
            })
        }
        
        this.setState({
            templateForm,
            formTaxDraftState
        })
    }

    checkInputValueNumber = (inputArray1, inputData) =>{
        if(inputArray1 == 1){
            if(inputData && inputData != ' '){
                return inputData.toFixed(2)
            }else{
                return (0).toFixed(2);
            }
        }else{
            if(inputData && inputData != ' '){
                return inputData.toFixed(2)
            }
            else{
                return (0).toFixed(2);
            }
        }
    }

    checkInputValueDate = (inputArray1, inputData) =>{
        if(inputArray1 == 1){
            if(inputData){
                return changeFormatdate(inputData)
            }else{
                return ''
            }
        }else{
            if(inputData){
                return changeFormatdate(inputData)
            }else{
                return ''
            }
        }
    }

    checkInputValueIntRadio = (inputArray1, inputData) =>{
        if(inputArray1 == 1){
            if(inputData){
                return parseInt(inputData)
            }else{
                return 0
            }
        }else{
            if(inputData){
                return parseInt(inputData)
            }else{
                return 0
            }
        }
    }

    checkInputValueString = (inputArray1, inputData) =>{
        if(inputArray1 == 1){
            if(inputData){
                return inputData
            }else{
                return ''
            }
        }else{
            if(inputData){
                return inputData
            }else{
                return ''
            }
        }
    }

    checkInputType = (data, valueSession, keyName) =>{
        const { formTaxDraftState } = this.state
        
        let returnData = [];

        if(data.type == 'date'){
            returnData['valueFormInput'] = changeFormatdate(formTaxDraftState[data.name]) ? changeFormatdate(formTaxDraftState[data.name]) : ' ';
            returnData['initialValueInput'] = this.checkInputValueDate(formTaxDraftState[valueSession.input[0].name], formTaxDraftState[data.name], data.name)
        }else if(data.type == 'int' || data.type == 'radio'){
            // console.log(data.name)
            if(data.name == 'isSponserFather' || data.name == 'isFatherHealthInsurance'){
                if(formTaxDraftState['fatherStatus'] == 'มีชีวิต'){
                    returnData['valueFormInput'] = parseInt(formTaxDraftState[data.name]) ? parseInt(formTaxDraftState[data.name]) : 0;
                    returnData['initialValueInput'] = this.checkInputValueIntRadio(formTaxDraftState[valueSession.input[0].name], formTaxDraftState[data.name], data.name)
                }else{
                    returnData['valueFormInput'] = 0;
                    returnData['initialValueInput'] = 0;
                }
            }else if(data.name == 'isSponserMother' || data.name == 'isMotherHealthInsurance'){
                if(formTaxDraftState['motherStatus'] == 'มีชีวิต'){
                    returnData['valueFormInput'] = parseInt(formTaxDraftState[data.name]) ? parseInt(formTaxDraftState[data.name]) : 0;
                    returnData['initialValueInput'] = this.checkInputValueIntRadio(formTaxDraftState[valueSession.input[0].name], formTaxDraftState[data.name], data.name)
                }else{
                    returnData['valueFormInput'] = 0;
                    returnData['initialValueInput'] = 0;
                }
            }else{
                returnData['valueFormInput'] = parseInt(formTaxDraftState[data.name]) ? parseInt(formTaxDraftState[data.name]) : 0;
                returnData['initialValueInput'] = this.checkInputValueIntRadio(formTaxDraftState[valueSession.input[0].name], formTaxDraftState[data.name], data.name)
            }
        }else if(data.type == 'number'){
            returnData['valueFormInput'] = parseInt(formTaxDraftState[data.name]) ? formTaxDraftState[data.name].toFixed(2).toString() : (0).toFixed(2);
            returnData['initialValueInput'] = this.checkInputValueNumber(formTaxDraftState[valueSession.input[0].name], formTaxDraftState[data.name], data.name)
        }else if(data.type == 'dropdown'){
            returnData['valueFormInput'] = formTaxDraftState[data.name] ? formTaxDraftState[data.name] : '';
            returnData['initialValueInput'] = this.checkInputValueString(formTaxDraftState[valueSession.input[0].name], formTaxDraftState[data.name], data.name)
        }else if(keyName == 'disabled'){
            returnData['valueFormInput'] = formTaxDraftState[data.name] ? formTaxDraftState[data.name] : '';
            returnData['initialValueInput'] = this.checkInputValueString(formTaxDraftState[valueSession.input[0].name], formTaxDraftState[data.name], data.name)
        }else{
            returnData['valueFormInput'] = formTaxDraftState[data.name] ? formTaxDraftState[data.name] : ' ';
            returnData['initialValueInput'] = this.checkInputValueString(formTaxDraftState[valueSession.input[0].name], formTaxDraftState[data.name], data.name)
        }

        return returnData;
    }

    showTextInputSponser = async (number, chanegRadio) =>{
        // console.log(e.target.value)
        const { templateForm }  = this.state
        const conditions = [];
        await templateForm.map((value, keys) =>{
            if(value.keyName == 'disabled'){
                if(value.keyForm <= number){
                    value.showDataForm = true
                }else{
                    value.showDataForm = false
                }
            }

			conditions[keys] = value
        })

        if(chanegRadio){
            await this.setState({
                templateForm:conditions,
                showTempalteInput: number
            })
        }else{
            await this.setState({
                templateForm:conditions,
            })
        }
    }

    checkDataMoney = (conditionsValue, keys) =>{
        if(conditionsValue == 1){
            if(keys.includes('Amnt')){
                return 30000
            }
        }else{
            if(keys.includes('Amnt')){
                return 0
            }
        }
    }

    onChangeKeyMonney =  (valueInput, keysInput, keySession, name) =>{
        const { templateForm, formTaxDraftState, showTempalteInput } = this.state
        const { formTaxDraft } = this.props
        if(valueInput == 0){
            templateForm[keySession].input.map((value, keys) =>{
                if(value.name.includes('Amnt')){
                    formTaxDraftState[value.name] = 0
                }else if(value.name.includes('isSponser')){
                    formTaxDraftState[value.name] = valueInput
                }
            })
        }else if(valueInput == 1){
            templateForm[keySession].input.map((value, keys) =>{
                if(value.name.includes('Amnt')){
                    formTaxDraftState[value.name] = 30000
                }else if(value.name.includes('isSponser')){
                    formTaxDraftState[value.name] = valueInput
                }
            })
        }
        
        this.setState({
            templateForm,
            formTaxDraftState
        })
    }

    checkRadioStatus = (name, valueForm, disabled) =>{
        if(name == 'isSponserFather' || name == 'isFatherHealthInsurance'){
            if(valueForm['fatherStatus'] == 'มีชีวิต'){
                return false
            }else{
                return true
            }
        }else if(name == 'isSponserMother'  || name == 'isMotherHealthInsurance'){
            if(valueForm['motherStatus'] == 'มีชีวิต'){
                return false
            }else{
                return true
            }
        }else{
            return disabled
        }
    }

    formColSead = (valueSession, keySession, data, keysInput) =>{
		const { formTaxDraftState, dropdownListRelation, showTempalteInput, dropdownListTitleMale, dropdownListTitleFemale } = this.state
        const { getFieldDecorator } = this.props.form;
		const radioStyle = {
			display: 'block',
			height: '30px',
			lineHeight: '30px',
        };

        let valueFormInput = this.checkInputType(data, valueSession, valueSession.keyName)['valueFormInput']
        let initialValueInput = this.checkInputType(data, valueSession, valueSession.keyName)['initialValueInput']
		return (
            <Col 
                xs={24} 
                sm={
                    data.name == 'fatherTitle' || data.name == 'motherTitle' || data.name == 'spouMotherTitle' || data.name == 'spouFatherTitle' ? 4 :
                    data.name == 'fatherFname' || data.name == 'motherFname' || data.name == 'spouFatherFname' || data.name == 'spouMotherFname' ? 8 :
                    12
                } 
                className="mb-3"
            >
				<div className="">
					{/* <Form.Item label={data.label+' '+data.name} > */}
					<Form.Item label={data.label}>
                    {
                            valueSession.conditions && keysInput == 0 &&
                                <>
                                    { getFieldDecorator(data.name, {
                                        initialValue: valueFormInput,
                                        rules:  [{ 
                                            required: true, 
                                            message: 'กรุณากรอกหรือเลือก '+data.label,
                                        }],
                                    })(
                                        <Radio.Group 
                                            // disabled={data.disable} 
                                            disabled={ this.checkRadioStatus(data.name, formTaxDraftState, data.disable)  }
                                            onChange={
                                                        (e) => this.onChangeConditions(e.target.value, keysInput, keySession, data.name)
                                                    }
                                        >
                                            {
                                                data.radioChoices.map((valueRadio, keys) =>{
                                                    return <Radio style={radioStyle} value={parseInt(valueRadio.value)}>
                                                        { valueRadio.label }
                                                    </Radio>
                                                })
                                            }
                                        </Radio.Group>
                                    )}
                                    {  
                                        data.subTitle &&
                                        <p style={{lineHeight:"1.5", color:"#8c8c8c",fontSize:"10px"}} >{ data.subTitle }</p>
                                    }
                                </>
                            ||
                                data.name.includes('isSponser') &&
                                <>
                                    { getFieldDecorator(data.name, {
                                        initialValue: valueFormInput,
                                        rules:  [{ 
                                            required: true, 
                                            message: 'กรุณากรอกหรือเลือก '+data.label,
                                        }],
                                    })(
                                        <Radio.Group 
                                            // disabled={ formTaxDraftState[valueSession.input[1].name] && (formTaxDraftState[valueSession.input[1].name] !== "" || formTaxDraftState[valueSession.input[1].name]) !== " " ? false : true  }
                                            disabled={ this.checkRadioStatus(data.name, formTaxDraftState)  }
                                            onChange={
                                                        (e) => this.onChangeKeyMonney(e.target.value, keysInput, keySession, data.name)
                                                    }
                                        >
                                            {
                                                data.radioChoices.map((valueRadio, keys) =>{
                                                    return <Radio style={radioStyle} value={parseInt(valueRadio.value)}>
                                                        { valueRadio.label }
                                                    </Radio>
                                                })
                                            }
                                        </Radio.Group>
                                    )}
                                    {  
                                        data.subTitle &&
                                        <p style={{lineHeight:"1.5", color:"#8c8c8c",fontSize:"10px"}} >{ data.subTitle }</p>
                                    }
                                </>

                            ||
                            <>
                                {
                                    data.name == 'isNumberOfDisabled' &&
                                        <>
                                            { getFieldDecorator(data.name, {
                                                initialValue: valueFormInput,
                                                rules:  [{ 
                                                    required: formTaxDraftState[valueSession.input[0].name] == true ? valueFormInput : false, 
                                                    message: 'กรุณากรอกหรือเลือก '+data.label,
                                                }],
                                            })(
                                                <InputNumber
                                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                    className={ !data.disable ? '' : 'font-italic' } 
                                                    disabled={ formTaxDraftState[valueSession.input[0].name] == 1 ? false : true }
                                                    min={data.min}
                                                    max={10}
                                                    onChange={ (e) => this.showTextInputSponser(e, true) }
                                                />
                                            )}
                                        </>
                                    ||
                                    valueSession.conditions && !keysInput == 0 &&
                                        <>
                                            {
                                                getFieldDecorator(data.name, {
                                                    initialValue: 
                                                                    data.label == 'บัตรประชาชน' ? initialValueInput && initialValueInput !== '0' ? initialValueInput : ' ' :
                                                                    this.checkDataMoney(formTaxDraftState[valueSession.input[0].name],data.name) || 
                                                                    this.checkDataMoney(formTaxDraftState[valueSession.input[0].name],data.name) == 0 ? 
                                                                    this.checkDataMoney(formTaxDraftState[valueSession.input[0].name],data.name) : 
                                                                    initialValueInput,
                                                    rules:  [{ 
                                                        required: formTaxDraftState[valueSession.input[0].name] == 1 ? true : false , 
                                                        message: 'กรุณากรอกหรือเลือก '+data.label,
                                                    }],
                                                })(
                                                    inputTax(
                                                        data, 
                                                        formTaxDraftState[valueSession.input[0].name] == 1 ? false : true ,
                                                        data.name == 'spouFatherTitle' ? dropdownListTitleMale  : data.name == 'spouMotherTitle' ? dropdownListTitleFemale : dropdownListRelation
                                                    )
                                                )
                                            }
                                        </> 
                                    ||
                                        valueSession.keyName == 'disabled' &&
                                            getFieldDecorator(data.name, {
                                                initialValue:   this.checkDataMoney(formTaxDraftState[valueSession.input[0].name],data.name) || 
                                                                this.checkDataMoney(formTaxDraftState[valueSession.input[0].name],data.name) == 0 ? 
                                                                this.checkDataMoney(formTaxDraftState[valueSession.input[0].name],data.name) : 
                                                                data.label == 'บัตรประชาชน' ? initialValueInput ? initialValueInput : ' ' :
                                                                initialValueInput,
                                                rules:  [{ 
                                                    required: formTaxDraftState['isSponserDisabled'] == 1 ? showTempalteInput >= valueSession.keyForm ? true : false : false,
                                                    message: 'กรุณากรอกหรือเลือก '+data.label,
                                                }],
                                                onChange: data.name == 'childBirthBefore2561' || data.name == 'childBirthAfter2561' || data.name == 'adoptedChild' ? (e) => this.changeValueChild(data.name, e) : ''
                                            })(
                                                inputTax(
                                                    data, 
                                                    data.disable, 
                                                    data.name == 'spouFatherTitle' ? dropdownListTitleMale  : data.name == 'spouMotherTitle' ? dropdownListTitleFemale : dropdownListRelation,
                                                    valueSession.input.length !== 1 && valueSession.input[0].type == 'radio' ? formTaxDraftState[valueSession.input[1].name] : '',
                                                )
                                            )
                                    ||
                                    data.disable &&
                                        <>
                                            {
                                                getFieldDecorator(data.name, {
                                                    initialValue:   this.checkDataMoney(formTaxDraftState[valueSession.input[0].name],data.name) || 
                                                                    this.checkDataMoney(formTaxDraftState[valueSession.input[0].name],data.name) == 0 ? 
                                                                    this.checkDataMoney(formTaxDraftState[valueSession.input[0].name],data.name) : 
                                                                    data.label == 'บัตรประชาชน' ? initialValueInput ? initialValueInput : ' ' :
                                                                    initialValueInput,
                                                    rules:  [{ 
                                                        required: false, 
                                                        message: 'กรุณากรอกหรือเลือก '+data.label,
                                                    }],
                                                })( 
                                                    inputTax(
                                                        data, 
                                                        data.disable, 
                                                        data.name == 'spouFatherTitle' || data.name == 'fatherTitle' ? dropdownListTitleMale  : data.name == 'spouMotherTitle' || data.name == 'motherTitle' ? dropdownListTitleFemale : dropdownListRelation,
                                                        valueSession.input.length !== 1 && valueSession.input[0].type == 'radio' ? formTaxDraftState[valueSession.input[1].name] : ''
                                                    )
                                                )
                                            }
                                        </>
                                    ||
                                    <>
                                        {
                                            getFieldDecorator(data.name, {
                                                initialValue: this.checkDataMoney(formTaxDraftState[valueSession.input[0].name],data.name) || this.checkDataMoney(formTaxDraftState[valueSession.input[0].name],data.name) == 0 ? this.checkDataMoney(formTaxDraftState[valueSession.input[0].name],data.name) : initialValueInput,
                                                rules:  [{ 
                                                    required: valueSession.keyName == 'disabled' ? false : true, 
                                                    message: 'กรุณากรอกหรือเลือก '+data.label,
                                                }],
                                                onChange: data.name == 'childBirthBefore2561' || data.name == 'childBirthAfter2561' || data.name == 'adoptedChild' ? (e) => this.changeValueChild(data.name, e) : ''
                                            })(
                                                inputTax(
                                                    data, 
                                                    data.disable, 
                                                    data.name == 'spouFatherTitle' ? dropdownListTitleMale  : data.name == 'spouMotherTitle' ? dropdownListTitleFemale : dropdownListRelation,
                                                    valueSession.input.length !== 1 && valueSession.input[0].type == 'radio' ? formTaxDraftState[valueSession.input[1].name] : '',
                                                    data.name
                                                )
                                                // <p>{valueSession.input[0].name}</p>
                                            )
                                        }
                                    </>
                                }
                                 {  
                                    data.subTitle &&
                                    <p style={{lineHeight:"1.5", color:"#b5b5b5",fontSize:"10px"}} >{ data.subTitle }</p>
                                }
                            </>
                        }
					</Form.Item>
				</div>
			</Col>
		)
    }

    checkSumValueChild = (childBirthBefore, childBirthAfter, adoptedChild) =>{
        const { formTaxDraftState, templateForm } = this.state
       
        if(childBirthBefore+childBirthAfter+adoptedChild  <= 3){
            return true
        }
        else{
            return false
        }
    }

    changeValueChild = (name, e ) =>{
        // name
        const { formTaxDraftState, templateForm } = this.state

        if(typeof e == 'string' || typeof e == 'object'){
            formTaxDraftState[name] = 0
        }else{
            formTaxDraftState[name] = e
        }
        
        let onCheckValues = this.checkSumValueChild(formTaxDraftState['childBirthBefore2561'], formTaxDraftState['childBirthAfter2561'], formTaxDraftState['adoptedChild']);
        if(onCheckValues !== true){
            window.scrollTo(0, 0);
            message.error(templateForm[2].alertText);
        }

        // console.log('formTaxDraftState',formTaxDraftState)
    }
    
    handleSubmitDarf = e => {
		const { form, afterSubmit, handleSubmitDarf, templateForm } = this.props
        e.preventDefault()
        let onCheckValues = ''
		form.validateFields((err, values) => {
            // console.log('ssssssss', values)
            if (!err) {
                onCheckValues = this.checkSumValueChild(values.childBirthBefore2561, values.childBirthAfter2561, values.adoptedChild);
                if(onCheckValues){
                    values.spouFatherIdentNo = values.spouFatherIdentNo.toString()
                    values.spouMotherIdentNo = values.spouMotherIdentNo.toString()
                    values.fatherIdentNo = values.fatherIdentNo.toString()
                    values.motherIdentNo = values.motherIdentNo.toString()
                    handleSubmitDarf(values)
                }else{
                    window.scrollTo(0, 0);
                    message.error(templateForm[2].alertText);
                }
            }
		})
	}

	handleSubmitSead = async () => {
		const { form, afterSubmit, handleSubmitSead } = this.props
        const { valuesForm } = this.state

        await this.setState({
            modalShow: false,
            description: null
        })

        valuesForm.spouFatherIdentNo = valuesForm.spouFatherIdentNo.toString()
        valuesForm.spouMotherIdentNo = valuesForm.spouMotherIdentNo.toString()
        valuesForm.fatherIdentNo = valuesForm.fatherIdentNo.toString()
        valuesForm.motherIdentNo = valuesForm.motherIdentNo.toString()

        // console.log('valuesForm',valuesForm)
        handleSubmitSead(valuesForm)
    }
    
    modalShow = async (e) =>{
        const { form, location, client } = this.props
		e.preventDefault()
		form.validateFields(async (err, values) => {
            if (!err) {

                const { data, errors } = await client.query({
                    query: Queries.confirmTextTaxDraft,
                })
                
                this.setState({
                    modalShow: true,
                    valuesForm: values,
                    description: data.confirmTextTaxDraft.description
                })
            }
		})
    }

    modalGuideLineTax = () =>{
		this.setState({
			modalGuideLineTax:true
		})
	}

    onChangeCheckBox = (value) =>{
        if(value){
            this.setState({
                checkBoxForm : false
            })
        }else{
            this.setState({
                checkBoxForm : true
            })
        }
    }

    async componentDidMount(){
        const { templateForm, formTaxDraft, dropdownListRelation,dropdownListTitleMale ,dropdownListTitleFemale  } = this.props

        await this.setState({
            templateForm,
            dropdownListRelation,
            formTaxDraftState: formTaxDraft,
            dropdownListTitleMale,
            dropdownListTitleFemale,
            showTempalteInput: formTaxDraft["isNumberOfDisabled"] ?  formTaxDraft["isNumberOfDisabled"] : 0
        })
        
        // console.log('templateForm',templateForm)
        // console.log('formTaxDraft',formTaxDraft)
	}

    render() {
        const { templateForm, formTaxDraftState, modalShow, description, dropdownListRelation, modalGuideLineTax, checkBoxForm } = this.state
        const { dataTabOne, guideLineTax } = this.props
        // console.log('formTaxDraftState',formTaxDraftState)
        return (
            <>
                <Modal
                    title= "ส่งเพื่อดำเนินการ"
                    style={{ top: 20 }}
                    visible={modalShow}
                    footer={[
                        <Button key="submit" type="primary" className="color-white" onClick={ () => this.handleSubmitSead()  }>ยืนยัน</Button>,
                        <Button key="back" onClick={ () => this.setState({ modalShow:false }) }>ยกเลิก</Button>,
                    ]}
                    onCancel={ () => this.setState({ modalShow:false }) }
                >
                    { description ? description : 'ยืนยันการส่งค่าลดหย่อนภาษี'}
                </Modal>
                <Form onSubmit={this.modalShow}>
                    <Row>
                        <Col md={8} xs={12}  className="mb-3">
                            <Button className="btn-guide-line px-2" style={{ backgroundColor:"red",color:"#fff", cursor:"default" }}>
                                ข้อมูลที่แสดงดังกล่าว นำมาจากบันทึกแบบร่าง
                            </Button>
                        </Col>
                        <Col md={16} xs={12}  className="mb-3">
                        <div align="right" className="div-guild-line">
                            <p style={{ display:"inline-block" }} className="mr-3">
                                <span className="mr-1">ปรังปรุงแก้ไขเมื่อ </span>
                                {changeFormatdate(dataTabOne.detailTax.updatedAt)}{moment(dataTabOne.detailTax.updatedAt).format(' | เวลา HH:mm น.')}
                            </p>
                            <Button className="btn-guide-line" onClick={ () => this.modalGuideLineTax() }>
                                คําแนะนําการใช้ฟอร์ม 
                            </Button>

                            <Modal
                                title= {<Title level={3} className="mb-0">คําแนะนําการใช้ฟอร์ม</Title>}
                                style={{ top: 20 }}
                                visible={modalGuideLineTax}
                                footer={[
                                    // <Button key="back" onClick={ () => this.setState({ modalGuideLineTax:false }) }>Return</Button>,
                                ]}
                                onCancel={ () => this.setState({ modalGuideLineTax:false }) }
                            >
                                <Title level={4}>{ guideLineTax.title }</Title>
                                { guideLineTax.description ? <div className="custom-modal-tax" dangerouslySetInnerHTML={{ __html: convertToHTMl(guideLineTax.description) }}/> : '' }
                            </Modal>
                        </div>
                        </Col>
                    </Row>
                    
                    {
                        ( templateForm.length !== 0 && dropdownListRelation.length !== 0)&&
                            <>
                                {
                                    templateForm.map((value, key)=>{
                                        return 	<>
                                                    <div style={{ display:value.showDataForm ? "block" : "none" }}>
                                                         
                                                        <Row gutter={16} type="flex" align="top" >
                                                            <Col xs={24} md={24} className="mb-2">
                                                                <strong className={ value.disableTitle ? "" : 'color-red' }>
                                                                    { value.name }<br></br>
                                                                    <p style={{lineHeight:"1.5", color:"#8c8c8c",fontSize:"12px"}} className="mb-0">{ value.descriptions }</p>
                                                                </strong> 
                                                            </Col>
                                                            {
                                                                value.input.map((valueInput, keysInput) => {
                                                                    return this.formColSead(value, key, valueInput, keysInput)
                                                                })
                                                            }
                                                        </Row>
                                                    </div>
                                                </>
                                    })
                                }
                            </>
                        ||
                        <Row gutter={16} type="flex" justify="space-between" align="top">
                            <Col span={24} align="center" className="mt-5">
                                <Spin size="large" />
                            </Col>
                        </Row>
                    }
                    <Row gutter={16} type="flex" justify="space-between" align="top" className="mt-4">
                        <Col span={24}>
                            <Checkbox onChange={(e) => this.onChangeCheckBox(e.target.checked)}>
                                <strong>ขอรับรองว่ารายการที่แสดงไว้เป็นความจริงทุกประการ </strong><br></br>
                                <span style={{ color:"#a2a2a2", display:"block", paddingLeft:"23px" }}>
                                    ซึ่งการให้ข้อมูลส่วนบุคคลใดๆ ของท่านเพื่อการปรับเปลี่ยนสัดส่วน “ค่าลดหย่อนภาษี” ท่านเป็นผู้รับผิดชอบในการกระทำดังกล่าวด้วยตนเอง โดยหน่วยงาน HR ทีมจ่ายเงินเดือนและภาษี จะไม่รับผิดชอบในข้อผิดพลาดหรือบกพร่อง หรือความเสียหายใดๆ อันอาจเกิดขึ้น และท่านจะไม่นำไปเป็นข้ออ้างยืนยัน และ/หรือใช้เป็นหลักฐานโต้แย้งหรือฟ้องร้องต่อสู้กับองค์กรแต่ประการใดทั้งสิ้น
                                    โดยข้อมูลดังกล่าว ถือว่าเป็นข้อมูลส่วนบุคคล ซึ่งข้าพเจ้ายินยอมให้เก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลดังกล่าวนี้ เพื่อส่งข้อมูลไปประมวลผลภาษีที่ระบบเงินเดือน (HRMI) ต่อไป
                                </span>
                            </Checkbox>
                        </Col>
                    </Row>
                    <Row gutter={16} type="flex" justify="space-between" align="top">
                        <Col span={24} align="center" className="mt-4">
                            <Button disabled={checkBoxForm} type="primary" className="mx-2 btn-link-page" htmlType="submit" onClick={this.handleSubmitDarf}>
                                บันทึกร่าง
                            </Button>
                            <Button disabled={checkBoxForm} type="primary" className="mx-2 color-white" htmlType="submit"  >
                                ส่งเพื่อดําเนินการ
                            </Button>
                        </Col>
                    </Row>
                    <Row gutter={16} type="flex" justify="space-between" align="top" className="mt-4">
                        <Col span={24}>
                            {
                                formTaxDraftState['updatedAt'] &&
                                <p className="mb-0">บันทึกร่างเมื่อ {changeFormatdate(formTaxDraftState['updatedAt'])}{moment(formTaxDraftState['updatedAt']).format(' | เวลา H:mm น.')}</p>
                            }
                            {
                                formTaxDraftState['sendDate'] &&
                                <p>ส่งเมื่อ {changeFormatdate(formTaxDraftState['sendDate'])}{moment(formTaxDraftState['sendDate']).format(' | เวลา H:mm น.')}</p>
                            }
                        </Col>
                    </Row>
				</Form>
            </>
        )
    }
}

FormInputTax.defaultProps = {
	autoFocus: false
}

FormInputTax.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedFormInputTax = Form.create()(FormInputTax)

export default withApollo(WrappedFormInputTax)